import React, { useState } from "react";
import { similarApi } from "../../api/auctiongate.js";

export default function SimilarCars() {
  const [vin, setVin] = useState("");
  const [make, setMake] = useState("");
  const [model, setModel] = useState("");
  const [year, setYear] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState(null);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      const body = { vin, make, model, year, page: 1 };
      Object.keys(body).forEach((k) => !body[k] && delete body[k]);
      const r = await similarApi.cars(body);
      setData(r);
    } catch (e2) {
      setError(e2?.message || "Search failed");
    } finally {
      setLoading(false);
    }
  };

  const items = extractItems(data);

  return (
    <div className="card">
      <div className="card__title">
        Similar Cars
        <span className="badge">stat.vin</span>
      </div>
      <form onSubmit={onSubmit} className="row" style={{ marginBottom: 10 }}>
        <input value={vin} onChange={(e) => setVin(e.target.value)} placeholder="VIN" style={input} />
        <input value={make} onChange={(e) => setMake(e.target.value)} placeholder="Make" style={input} />
        <input value={model} onChange={(e) => setModel(e.target.value)} placeholder="Model" style={input} />
        <input value={year} onChange={(e) => setYear(e.target.value)} placeholder="Year" style={{ ...input, width: 90 }} />
        <button className="btn btn-accent" type="submit" disabled={loading}>
          {loading ? <span className="loader" /> : "Search"}
        </button>
      </form>
      {error && <div className="login-error">{error}</div>}
      {!error && items.length === 0 && data && (
        <div className="placeholder-panel">No similar cars found.</div>
      )}
      {items.length > 0 && (
        <div className="small" style={{ maxHeight: 240, overflow: "auto" }}>
          {items.slice(0, 20).map((it, i) => (
            <div key={it.id ?? i} style={rowStyle}>
              <span style={{ fontFamily: "monospace" }}>{it.vin || "—"}</span>
              <span>
                {[it.year, it.make, it.model].filter(Boolean).join(" ")}
              </span>
              <span className="muted">{it.auction || it.source || ""}</span>
              <span style={{ fontWeight: 600, textAlign: "right" }}>
                {it.purchase_price ? `$${it.purchase_price}` : "-"}
              </span>
            </div>
          ))}
          {items.length > 20 && <div className="muted mt-2">…and {items.length - 20} more</div>}
        </div>
      )}
    </div>
  );
}

function extractItems(d) {
  if (!d) return [];
  if (Array.isArray(d)) return d;
  if (Array.isArray(d.data)) return d.data;
  if (Array.isArray(d?.data?.data)) return d.data.data;
  if (Array.isArray(d?.items)) return d.items;
  return [];
}

const input = {
  padding: "7px 10px",
  border: "1px solid var(--color-border-input)",
  borderRadius: 8,
  fontSize: 13,
  minWidth: 110,
};
const rowStyle = {
  display: "grid",
  gridTemplateColumns: "1.5fr 1.5fr .8fr .6fr",
  gap: 8,
  padding: "6px 8px",
  borderBottom: "1px solid var(--color-border)",
};
